import React, { useState } from 'react';
import Table from "react-bootstrap/Table";
import { styles } from "../../styles/styles.js";
import { useAppState } from "../../AppStateContext.js";
import ReactMarkdown from "react-markdown";
import { fmt, sum, diff, mean } from "../../utils/format.js";

const Totals = ({ fixture }) => {
  const [showPointDifference, setShowPointDifference] = useState(true);
  const { isTutorialMode } = useAppState();

  const togglePointDifference = () => {
    setShowPointDifference(!showPointDifference);
  };

  if (!fixture.recent) return null;


  return (
    <>
      <Table bordered className="main" onClick={togglePointDifference}>
        <tbody>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1}>Point Totals</td>
            <td className="Cells" style={styles.Cells}> </td>
            <td className="Cells" style={styles.Cells}> </td>
            <td className="Cells" style={styles.Cells}> </td>
            <td className="Cells" style={styles.Cells}> </td>
          </tr>
          <tr>
            <td className="Cells" style={styles.column_1}> </td>
            <td className="Cells" style={styles.column_1}>{fixture.home_team}</td>
            <td className="Cells" style={styles.column_1}>{fixture.away_team}</td>
            <td className="Cells" style={styles.column_1}>Average</td>
            <td className="Cells" style={styles.column_1}>Delta</td>
          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1}>Last 3</td>
            <td className="Cells" style={styles.Cells}>
              {fmt(sum(fixture.recent.home_PF_3, fixture.recent.home_PA_3))}
            </td>
            <td className="Cells" style={styles.Cells}>
              {fmt(sum(fixture.recent.away_PF_3, fixture.recent.away_PA_3))}
            </td>
            <td className="Cells" style={styles.Cells}>
              {fmt(mean(sum(fixture.recent.home_PF_3, fixture.recent.home_PA_3), sum(fixture.recent.away_PF_3, fixture.recent.away_PA_3)))}
            </td>
            <td className="Cells" style={styles.Cells}>
              {fmt(diff(mean(sum(fixture.recent.home_PF_3, fixture.recent.home_PA_3), sum(fixture.recent.away_PF_3, fixture.recent.away_PA_3)), fixture.over), 1, { signed: true })}
            </td>
          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1}>Last 5</td>
            <td className="Cells" style={styles.Cells}>
              {fmt(sum(fixture.recent.home_PF_5, fixture.recent.home_PA_5))}
            </td>
            <td className="Cells" style={styles.Cells}>
              {fmt(sum(fixture.recent.away_PF_5, fixture.recent.away_PA_5))}
            </td>
            <td className="Cells" style={styles.Cells}>
              {fmt(mean(sum(fixture.recent.home_PF_5, fixture.recent.home_PA_5), sum(fixture.recent.away_PF_5, fixture.recent.away_PA_5)))}
            </td>
            <td className="Cells" style={styles.Cells}>
              {fmt(diff(mean(sum(fixture.recent.home_PF_5, fixture.recent.home_PA_5), sum(fixture.recent.away_PF_5, fixture.recent.away_PA_5)), fixture.over), 1, { signed: true })}
            </td>
          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1}>Last 10</td>
            <td className="Cells" style={styles.Cells}>
              {fmt(sum(fixture.recent.home_PF_10, fixture.recent.home_PA_10))}
            </td>
            <td className="Cells" style={styles.Cells}>
              {fmt(sum(fixture.recent.away_PF_10, fixture.recent.away_PA_10))}
            </td>
            <td className="Cells" style={styles.Cells}>
              {fmt(mean(sum(fixture.recent.home_PF_10, fixture.recent.home_PA_10), sum(fixture.recent.away_PF_10, fixture.recent.away_PA_10)))}
            </td>
            <td className="Cells" style={styles.Cells}>
              {fmt(diff(mean(sum(fixture.recent.home_PF_10, fixture.recent.home_PA_10), sum(fixture.recent.away_PF_10, fixture.recent.away_PA_10)), fixture.over), 1, { signed: true })}
            </td>
          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1}>Season</td>
            <td className="Cells" style={styles.Cells}>
              {fmt(sum(fixture.stats?.home_PF, fixture.stats?.home_PA))}
            </td>
            <td className="Cells" style={styles.Cells}>
              {fmt(sum(fixture.stats?.away_PF, fixture.stats?.away_PA))}
            </td>
            <td className="Cells" style={styles.Cells}>
              {fmt(mean(sum(fixture.stats?.home_PF, fixture.stats?.home_PA), sum(fixture.stats?.away_PF, fixture.stats?.away_PA)))}
            </td>
            <td className="Cells" style={styles.Cells}>
              {fmt(diff(mean(sum(fixture.stats?.home_PF, fixture.stats?.home_PA), sum(fixture.stats?.away_PF, fixture.stats?.away_PA)), fixture.over), 1, { signed: true })}
            </td>
          </tr>
          {shouldShowLastSeason(fixture) && (
            <tr style={styles.Cells}>
              <td className="Cells" style={styles.column_1}>Last Season</td>
              <td className="Cells" style={styles.Cells}>
                {fmt(sum(fixture.stats?.home_PF_last, fixture.stats?.home_PA_last))}
              </td>
              <td className="Cells" style={styles.Cells}>
                {fmt(sum(fixture.stats?.away_PF_last, fixture.stats?.away_PA_last))}
              </td>
              <td className="Cells" style={styles.Cells}>
                {fmt(mean(sum(fixture.stats?.home_PF_last, fixture.stats?.home_PA_last), sum(fixture.stats?.away_PF_last, fixture.stats?.away_PA_last)))}
              </td>
              <td className="Cells" style={styles.Cells}>
                {fmt(diff(mean(sum(fixture.stats?.home_PF_last, fixture.stats?.home_PA_last), sum(fixture.stats?.away_PF_last, fixture.stats?.away_PA_last)), fixture.over), 1, { signed: true })}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <div style={{ height: '10vh' }}></div>

      <div style={{ marginTop: '20px' }}>
        {fixture.box_score && (
          <ul style={{ 
            listStyleType: 'none', 
            padding: 0,
            margin: 0,
            fontSize: 'clamp(10px, calc(7px + (4) * ((100vw - 300px) / (1200 - 320))), 18px)'
          }}>
            <ReactMarkdown>{fixture.box_score['totals_stats']}</ReactMarkdown>
          </ul>
        )}
      </div>

      {isTutorialMode && (
        <ul style={{ fontSize: 'clamp(12px, calc(12px + (4) * ((100vw - 300px) / (1200 - 320))), 18px)', marginBottom: '20px', textAlign: 'left', listStyleType: 'none', paddingLeft: '0' }}>
          <li>• This table shows the total points (Points For + Points Against) for each team</li>
          <li>• Columns explanation:
            <ul style={{ paddingLeft: '20px', listStyleType: 'none' }}>
              <li>◦ Home/Away - Total points for each team (PF + PA)</li>
              <li>◦ Average - Combined average of both teams' totals</li>
              <li>◦ Delta - Difference between the average and the over/under set by the market</li>
            </ul>
          </li>
          <li>• A positive Delta suggests the total might go over, while a negative Delta suggests it might go under</li>
        </ul>
      )}
    </>
  );
};

function shouldShowLastSeason(fixture) {
  if (fixture.league === "NFL") {
    return true;
  }
  // Unknown season progress is not early-season. Showing a "Last Season" row we
  // cannot justify is worse than omitting it, and the old unguarded deref threw.
  return fixture.ratings?.progress != null && fixture.ratings.progress < 0.15;
}

export default Totals;